var $ = require("jquery");

module.exports = {
	init: function () {
		// Scroll - Change header bg color
		var header = document.querySelector(".header");
		window.addEventListener("scroll", function () {
			if (window.pageYOffset > 0) {
				header.classList.add("bg");
			} else {
				header.classList.remove("bg");
			}
		});

		// Nav toggle
		$(".nav-toggle").on("click", function () {
			$(".header").toggleClass("active");
			$(".header-nav").toggleClass("active");
		});

		// Search
		var searchEvents = function () {
			// Open click event
			$(".menu-item.search .open-search").on("click", function (evt) {
				evt.preventDefault();
				$(this).parent().parent().toggleClass("active");
				$(this).parent().parent().parent().toggleClass("search-open");
				if ($(".menu-item.search").hasClass("active")) {
					setTimeout(function (evt) {
						$('.menu-item.search input[type="text"]').focus();
					}, 300);
				}
			});
			// If tabbing through, open the search bar
			$('.menu-item.search input[type="text"]').on(
				"focus",
				function (evt) {
					$(".menu-item.search").addClass("active");
					$(".menu-item.search").parent().addClass("search-open");
				}
			);
			// If tabbing the opposite direction, open the search bar
			$(".menu-item.search .close").on("focus", function (evt) {
				$(".menu-item.search").addClass("active");
				$(".menu-item.search").parent().addClass("search-open");
			});
			// Close click event
			$(".menu-item.search .close").on("click", function (evt) {
				evt.preventDefault();
				$(this).parent().parent().toggleClass("active");
				$(this).parent().parent().parent().toggleClass("search-open");
			});
		};

		// Save original search link markup in a variable
		// This is used for mobile
		if ($(".menu-item.search").length > 0) {
			var originalHtml = $(".menu-item.search a");
		}

		if (window.innerWidth <= 768) {
			// Mobile menu
			$(".header-nav").addClass("mobile");
			$(".footer .footer-menu")
				.clone()
				.insertAfter(".header-nav .main-menu.right");
			$(".footer .social-menu")
				.clone()
				.insertAfter(".header-nav .footer-menu");
		} else if (window.innerWidth > 768) {
			// Header Search
			if ($(".menu-item.search").length > 0) {
				var searchHtml =
					'<div class="search-container"><button type="button" class="open-search"><span class="visually-hide-text">Open Search</span><i class="far fa-search"></i></button><form id="search-form" class="search" action="/search-results/" method="get"><label for="search-field"><span class="visually-hidden">Search</span><input id="search-field" type="text" name="fwp_search" value=""></label><button id="search-submit" class="submit" form="search-form" type="submit">Search</button></form><button type="button" class="close"><span class="visually-hidden">Close</span><i class="fal fa-times"></i></button></div>';
				$(".menu-item.search").html(searchHtml).addClass("ready");

				searchEvents();
			}
		}

		window.addEventListener("resize", function () {
			// Header Nav
			if (
				window.innerWidth > 768 &&
				$(".header-nav").hasClass("mobile")
			) {
				$(".header-nav").removeClass("mobile");
				$(".header-nav .footer-menu").remove();
				$(".header-nav .social-menu").remove();
			} else if (
				window.innerWidth <= 768 &&
				!$(".header-nav").hasClass("mobile")
			) {
				$(".header-nav").addClass("mobile");
				$(".footer .footer-menu")
					.clone()
					.insertAfter(".header-nav .main-menu.right");
				$(".footer .social-menu")
					.clone()
					.insertAfter(".header-nav .footer-menu");
			}

			// Header Search
			if (
				window.innerWidth > 768 &&
				!$(".menu-item.search").hasClass("ready")
			) {
				var searchHtml =
					'<div class="search-container"><button type="button" class="open-search"><span class="visually-hide-text">Open Search</span><i class="far fa-search"></i></button><form id="search-form" class="search" action="/search-results/" method="get"><label for="search-field"><span class="visually-hidden">Search</span><input id="search-field" type="text" name="fwp_search" value=""></label><button id="search-submit" class="submit" form="search-form" type="submit">Search</button></form><button type="button" class="close"><span class="visually-hidden">Close</span><i class="fal fa-times"></i></button></div>';
				$(".menu-item.search").html(searchHtml).addClass("ready");
				searchEvents();
			} else if (
				window.innerWidth <= 768 &&
				$(".menu-item.search").hasClass("ready")
			) {
				$(".menu-item.search").html(originalHtml).removeClass("ready");
			}
		});
	},
};
